import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import login from 'redux-store/reducers/login';
import credito from 'redux-store/reducers/credito';
import poliza from 'redux-store/reducers/poliza';
import garantia from 'redux-store/reducers/garantia';
import corredorGarantia from 'redux-store/reducers/corredorGarantia';
import corredorCredito from 'redux-store/reducers/corredorCredito';

const rootReducer = combineReducers({
  login,
  credito,
  garantia,
  poliza,
  corredorGarantia,
  corredorCredito,
  routing: routerReducer,
});

export default rootReducer;
